(function () {
  'use strict';

  if (window.LivvewellFooter && window.LivvewellFooter.__loaded) {
    return;
  }

  window.LivvewellFooter = {
    __loaded: true
  };

  function init(scope) {
    var root = scope || document;

    root
      .querySelectorAll('[data-lw-footer]')
      .forEach(function (footer) {
        if (footer.dataset.lwFooterReady === 'true') {
          return;
        }

        footer.dataset.lwFooterReady = 'true';

        var countrySelect =
          footer.querySelector('[data-lw-footer-country]');

        if (countrySelect) {
          countrySelect.addEventListener('change', function () {
            var form = countrySelect.closest('form');

            if (form) {
              form.submit();
            }
          });
        }

        var success =
          footer.querySelector('.lw-footer__form-message.is-success');

        if (success) {
          window.setTimeout(function () {
            success.focus();
          }, 50);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
